export enum TruncationType {
  Beginning = 'Beginning',
  Middle = 'Middle',
  End = 'End',
}
